<template><div class="loading-stack" aria-label="Загрузка"><span /><span /><span /></div></template>
